<script lang="ts" setup>
import { nextTick, ref } from 'vue';
import type { RecommendItem } from '@/utils/type';
import ArticleTitle from '@/components/standardComponents/metaComponent/ArticleTitle/ArticleTitle.vue';
import MainContent from '@/components/standardComponents/metaComponent/MainContent/MainContent.vue';
import useCloseBtnVisibility from '@/hooks/useCloseBtnVisibility';
import Image from '@/components/common/Image/Image.vue';

const props = defineProps<{
    // 内容数据
    item: RecommendItem;
    // 组件配置
    contentConfig: {
        defaultExpand: boolean;
        abstractRow: number;
    };
}>();

// 监听 titleRef 和 endRef 的曝光, 进而控制 Close 按钮的显示
const titleRef = ref<HTMLDivElement | null>(null);
const endRef = ref<HTMLDivElement | null>(null);
const { isHide } = useCloseBtnVisibility(titleRef, endRef);

const expanded = ref(props.contentConfig.defaultExpand);

// 处理推荐项的展开/收起
const bannerRef = ref<HTMLDivElement | null>(null);
const closeContent = () => {
    expanded.value = false;
    // 如果对应的 bannerRef 在可视区的上方, 则将其滚动到可见区域
    nextTick(() => {
        if (!bannerRef.value) return;
        const rect = bannerRef.value.getBoundingClientRect();
        if (rect.top < 0) {
            bannerRef.value.scrollIntoView();
        }
    });
};
const expandContent = () => {
    expanded.value = true;
};
</script>

<template>
    <div class="card_article">
        <div ref="bannerRef">
            <Image
                :src="item.banner"
                class="card_recommendation_header_image"
                lazy
            />
        </div>

        <div ref="titleRef">
            <ArticleTitle
                class="card_recommendation_item_title"
                :data="{ title: item.title, publisher: item.publisher }"
            />
        </div>

        <div class="card_recommendation_item_content">
            <MainContent
                :item="item"
                :expanded="expanded"
                :abstractRow="contentConfig.abstractRow"
                :hideCloseBtn="isHide"
                @expandContent="expandContent"
                @closeContent="closeContent"
            />

            <div ref="endRef" class="card_recommendation_item_end"></div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use './Item.scss';
</style>
